import React from "react";
import { Sparkles, ArrowRight, Plus } from "lucide-react";

/**
 * Phase FOLDER-UX (FU.3) — small floating chip that follows the
 * cursor during a workflow drag.  Rendered inside @dnd-kit's
 * <DragOverlay>.
 *
 * Props:
 *   workflowName        single-workflow drag — the row's name
 *   selectedCount       if > 1, indicates bulk drag and the label
 *                       shows "[N workflows]" instead of the name
 *   shiftHeld           toggles between "+ Add" and "→ Move" badge
 */
export default function WorkflowDragChip({
  workflowName,
  selectedCount = 1,
  shiftHeld = false,
  testid = "workflow-drag-chip",
}) {
  const isBulk = selectedCount > 1;
  const label = isBulk
    ? `${selectedCount} workflows`
    : workflowName || "Workflow";
  return (
    <div
      className="pointer-events-none flex items-center gap-2 rounded-md bg-slate-900 px-3 py-2 text-xs font-medium text-white shadow-xl ring-2 ring-indigo-400/40"
      data-testid={testid}
      data-shift-held={shiftHeld ? "true" : "false"}
    >
      <Sparkles size={12} className="text-indigo-300" />
      <span className="max-w-[200px] truncate">{label}</span>
      <span
        className={[
          "inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider",
          shiftHeld
            ? "bg-rose-500 text-white"
            : "bg-indigo-500 text-white",
        ].join(" ")}
        data-testid={`${testid}-mode`}
        data-mode={shiftHeld ? "move" : "add"}
      >
        {shiftHeld ? (
          <>
            <ArrowRight size={9} strokeWidth={3} />
            Move
          </>
        ) : (
          <>
            <Plus size={9} strokeWidth={3} />
            Add
          </>
        )}
      </span>
    </div>
  );
}
